<template>
  <div>
    <label class="form-label">{{ label || "Select" }}</label>
    <select @change="emitFilter" class="form-control" :value="realValue">
      <option
        v-for="(option, index) in options"
        :key="index"
        :value="option.value"
        >{{ option.label }}</option
      >
    </select>
  </div>
</template>

<script lang="babel">
export default {
  props: {
    value: null,
    label: null,
    id: null,
    attributes: null,
    options: {
      required: true,
      type: Array
    }
  },
  computed: {
    realValue() {
      if (!this.value) {
        return null;
      }

      return this.value[this.attributes];
    }
  },
  methods: {
    emitFilter(event) {
      if (event.target.value) {
        this.$emit("filter-change", {
          id: this.id,
          name: "where",
          attributes: {
            [this.attributes]: event.target.value,
          }
        });
      } else {
        this.$emit("filter-change", { id: this.id });
      }
    }
  }
};
</script>
